import { Field, WysiwygField } from '../../../libs/gs-component-form';
import { Content } from '../../../libs/gs-component-right-rail';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { Field as FormikField, Form as FormikForm } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { Wws_BasicItem, Wws_StoryItem, StoryItemsFragment, BasicItemsFragment } from '../../../generated/graphql';
import { SharedFormProps } from '../../../helpers/useManageItem';
import { Footer } from '../../FormComponents';
import { DeleteOrDiscard } from '../DeleteOrDiscard';
import { ImageField } from '../ImageField';
import styles from './index.scss';
import { useAiTextExperimentContext } from '../../../context/AiTextExperimentContext';

export const validationSchema = Yup.object().shape({
  title: Yup.string().required(),
  description: Yup.string().nullable(),
});

export interface PhotoValues {
  mediaUrl?: string | null;
  mediaApiId: string | null;
  cropX: number | null;
  cropY: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
  aspectRatio?: any;
  __typename?: string;
}

export interface InitialValues {
  title?: string | null;
  description?: string | null;
  photo: PhotoValues;
}

interface Props extends SharedFormProps {
  item?: Wws_StoryItem | Wws_BasicItem;
  pageId: number;
}

export const initialValues = (item?: StoryItemsFragment | BasicItemsFragment | null): InitialValues => ({
  title: item?.title || '',
  description: item?.description || '',
  photo: {
    mediaUrl: item?.photo?.mediaUrl || null,
    mediaApiId: item?.photo?.mediaApiId || null,
    width: item?.photo?.width || null,
    height: item?.photo?.height || null,
    cropX: item?.photo?.cropX || null,
    cropY: item?.photo?.cropY || null,
    rotation: item?.photo?.rotation || null,
  },
});

const Form: React.FC<Props> = ({ submitForm, loading, updating, item, discardOrDelete, pageId, close }) => {
  const { showAiButton } = useAiTextExperimentContext();
  return (
    <>
      <Content className={styles.content} loading={loading}>
        <FormikForm>
          <FormBlockColumn>
            <div className={styles.imageBox}>
              <FormikField
                component={ImageField}
                name="photo.mediaUrl"
                pageId={pageId}
                parentItemType="StoryItem"
                imageFieldName="photo"
              />
            </div>
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField name="title" label="Title" component={Field} data-testid="title" showAiButton={showAiButton} />
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField
              name="description"
              placeholder="Tell your story here..."
              component={WysiwygField}
              showAiButton={showAiButton}
            />
          </FormBlockColumn>
          {/* Because you cannot add a basic/story item on new CV so okay to hard code*/}
          <DeleteOrDiscard onClick={discardOrDelete} isNew={false}>
            {item?.__typename === 'WWS_BasicItem' ? 'Delete page item' : 'Delete story item'}
          </DeleteOrDiscard>
        </FormikForm>
      </Content>
      <Footer primaryOnClick={submitForm} showSpinner={updating} useSaveAndPreview={true} secondaryOnClick={close} />
    </>
  );
};

export default Form;
